import { useMemo } from 'react'
import { Outlet } from 'react-router-dom'
import { Select } from '@/components/Select'
import { CampaignTotpStepUpProvider } from '@/contexts/CampaignTotpStepUpContext'
import { useInstitutionCampaignSelect } from '@/hooks/useInstitutionCampaignSelect'
import styles from './WinnerLookupLayout.module.css'

export type WinnerLookupLayoutOutletContext = {
  campaignId: number | null
  campaignsLoading: boolean
  hasCampaigns: boolean
}

export function WinnerLookupLayout() {
  const {
    campaignOptions,
    campaignValue,
    handleCampaignValueChange,
    selectPlaceholder,
    campaignsLoading,
    campaignsError,
    persistError,
    isSelectorDisabled,
    campaignId,
  } = useInstitutionCampaignSelect()

  const outletContext = useMemo<WinnerLookupLayoutOutletContext>(
    () => ({
      campaignId,
      campaignsLoading,
      hasCampaigns: campaignOptions.length > 0,
    }),
    [campaignId, campaignsLoading, campaignOptions.length]
  )

  return (
    <CampaignTotpStepUpProvider>
      <div className={styles.page}>
        <header className={styles.header}>
          <div className={styles.headerText}>
            <h1 className={styles.title}>Ganhadores</h1>
            <p className={styles.subtitle}>
              Escolha a campanha de sorteio para ranking, roleta e busca da cota. A raspadinha tem
              seletor próprio no bloco correspondente.
            </p>
          </div>
          <div className={styles.headerActionWrap}>
            <div className={styles.campaignSelector}>
              <Select
                id="winner-lookup-campanha-select"
                value={campaignValue}
                onChange={handleCampaignValueChange}
                options={campaignOptions}
                placeholder={selectPlaceholder}
                label="Campanha de sorteio"
                icon="mdi:bullhorn"
                disabled={isSelectorDisabled}
              />
              {campaignsError ? (
                <p className={styles.campaignSelectorError} role="alert">
                  {campaignsError}
                </p>
              ) : null}
              {persistError ? (
                <p className={styles.campaignSelectorError} role="alert">
                  {persistError}
                </p>
              ) : null}
            </div>
          </div>
        </header>

        <div className={styles.content}>
          <Outlet context={outletContext} />
        </div>
      </div>
    </CampaignTotpStepUpProvider>
  )
}
